export enum CHANGE_REASON {
  AccountingErrorOrObviousMistake = 1,
  SalesDepartmentError = 2,
  InvoicingDepartmentError = 3,
  CommercialDepartmentOrDZPError = 4,
  ApplicationError = 5,
  SubsequentEconomicEventAffectingSalesValue = 6,
  ChangeOrReturn = 7,
  AdditionalChargeAsPurchaseOrOrderChange = 8,
  CollectiveCorrectionInvoice = 9,
  BuyerChange = 10,
  IncorrectBuyer = 11,
  AdditionalChargeOrChange = 12,
  ChangeOfPaymentMethodInPayments = 13,
}
